// Code Owner: #project-xpert-platform
import React from 'react';
import PropTypes from 'prop-types';

import isValidAudience from '@prospectus/common/ui/xpert/shared/utils';
import './styles.scss';

let Chatbot;

if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  Chatbot = require('@2uinc/frontend-component-xpert-chatbot').Chatbot;
}

function XpertChatbot(props) {
  if (Chatbot && isValidAudience()) {
    const getPayloadParams = () => {
      props.tracking?.trackEvent?.({});
      const { dataLayer = [] } = window;
      return dataLayer.length ? dataLayer[dataLayer.length - 1] : {};
    };

    return <Chatbot xpertKey="edx" configurations={{ userTracking: { payloadParams: getPayloadParams() } }} />;
  }
  return null;
}

XpertChatbot.propTypes = {
  tracking: PropTypes.shape().isRequired,
};

export default XpertChatbot;
